import React from "react";
import {useEnvValue} from "@morningtrain/react-helpers";

export default function usePageTitle() {

    const [title] = useEnvValue('page.title');

    return title;
}
